import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enHomeParents from './locales/en/home-parents.json';
import enHomeEducators from './locales/en/home-educators.json';
import enHomeCommunity from './locales/en/home-community.json';
import enBudgetPlanner from './locales/en/budget-planner.json';
import enBudgetPlannerGuide from './locales/en/budget-planner-guide.json';
import enFoodTruckPlanner from './locales/en/food-truck-planner.json';
import enFoodTruckPlannerGuide from './locales/en/food-truck-planner-guide.json';
import enCreditAssessment from './locales/en/credit-assessment.json';
import enCreditAssessmentGuide from './locales/en/credit-assessment-guide.json';
import enRetirementPlanner from './locales/en/retirement-planner.json';
import enRetirementPlannerGuide from './locales/en/retirement-planner-guide.json';
import enUnderstandingTaxes from './locales/en/understanding-taxes.json';
import enUnderstandingTaxesGuide from './locales/en/understanding-taxes-guide.json';
import enAdmin from './locales/en/admin.json';
import enNavigation from './locales/en/navigation.json';
import enAllowanceSavingsElem from './locales/en/allowance-savings-elem.json';
import enCharitableGivingElem from './locales/en/charitable-giving-elem.json';
import enGoalSettingElem from './locales/en/goal-setting-elem.json';
import enLemonadeStandElem from './locales/en/lemonade-stand-elem.json';
import enWantsNeedsElem from './locales/en/wants-needs-elem.json';
import enSubscriptionPlans from './locales/en/subscription-plans.json';
import enPrvProspecting from './locales/en/prv-prospecting.json';
import enPrvProspectingData from './locales/en/prv-prospecting-data.json';
import enUserDashboard from './locales/en/user-dashboard.json';

// Spanish
import esCommon from './locales/es/common.json';
import esHome from './locales/es/home.json';
import esHomeParents from './locales/es/home-parents.json';
import esHomeEducators from './locales/es/home-educators.json';
import esHomeCommunity from './locales/es/home-community.json';
import esBudgetPlanner from './locales/es/budget-planner.json';
import esBudgetPlannerGuide from './locales/es/budget-planner-guide.json';
import esFoodTruckPlanner from './locales/es/food-truck-planner.json';
import esFoodTruckPlannerGuide from './locales/es/food-truck-planner-guide.json';
import esCreditAssessment from './locales/es/credit-assessment.json';
import esCreditAssessmentGuide from './locales/es/credit-assessment-guide.json';
import esRetirementPlanner from './locales/es/retirement-planner.json';
import esRetirementPlannerGuide from './locales/es/retirement-planner-guide.json';
import esUnderstandingTaxes from './locales/es/understanding-taxes.json';
import esUnderstandingTaxesGuide from './locales/es/understanding-taxes-guide.json';
import esAdmin from './locales/es/admin.json';
import esNavigation from './locales/es/navigation.json';
import esAllowanceSavingsElem from './locales/es/allowance-savings-elem.json';
import esCharitableGivingElem from './locales/es/charitable-giving-elem.json';
import esGoalSettingElem from './locales/es/goal-setting-elem.json';
import esLemonadeStandElem from './locales/es/lemonade-stand-elem.json';
import esWantsNeedsElem from './locales/es/wants-needs-elem.json';
import esSubscriptionPlans from './locales/es/subscription-plans.json';
import esPrvProspecting from './locales/es/prv-prospecting.json';
import esPrvProspectingData from './locales/es/prv-prospecting-data.json';
import esUserDashboard from './locales/es/user-dashboard.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        home: enHome,
        'home-parents': enHomeParents,
        'home-educators': enHomeEducators,
        'home-community': enHomeCommunity,
        'budget-planner': enBudgetPlanner,
        'budget-planner-guide': enBudgetPlannerGuide,
        'food-truck-planner': enFoodTruckPlanner,
        'food-truck-planner-guide': enFoodTruckPlannerGuide,
        'credit-assessment': enCreditAssessment,
        'credit-assessment-guide': enCreditAssessmentGuide,
        'retirement-planner': enRetirementPlanner,
        'retirement-planner-guide': enRetirementPlannerGuide,
        'understanding-taxes': enUnderstandingTaxes,
        'understanding-taxes-guide': enUnderstandingTaxesGuide,
        admin: enAdmin,
        navigation: enNavigation,
        'allowance-savings-elem': enAllowanceSavingsElem,
        'charitable-giving-elem': enCharitableGivingElem,
        'goal-setting-elem': enGoalSettingElem,
        'lemonade-stand-elem': enLemonadeStandElem,
        'wants-needs-elem': enWantsNeedsElem,
        'subscription-plans': enSubscriptionPlans,
        'prv-prospecting': enPrvProspecting,
        'prv-prospecting-data': enPrvProspectingData,
        'user-dashboard': enUserDashboard,
      },
      es: {
        common: esCommon,
        home: esHome,
        'home-parents': esHomeParents,
        'home-educators': esHomeEducators,
        'home-community': esHomeCommunity,
        'budget-planner': esBudgetPlanner,
        'budget-planner-guide': esBudgetPlannerGuide,
        'food-truck-planner': esFoodTruckPlanner,
        'food-truck-planner-guide': esFoodTruckPlannerGuide,
        'credit-assessment': esCreditAssessment,
        'credit-assessment-guide': esCreditAssessmentGuide,
        'retirement-planner': esRetirementPlanner,
        'retirement-planner-guide': esRetirementPlannerGuide,
        'understanding-taxes': esUnderstandingTaxes,
        'understanding-taxes-guide': esUnderstandingTaxesGuide,
        admin: esAdmin,
        navigation: esNavigation,
        'allowance-savings-elem': esAllowanceSavingsElem,
        'charitable-giving-elem': esCharitableGivingElem,
        'goal-setting-elem': esGoalSettingElem,
        'lemonade-stand-elem': esLemonadeStandElem,
        'wants-needs-elem': esWantsNeedsElem,
        'subscription-plans': esSubscriptionPlans,
        'prv-prospecting': esPrvProspecting,
        'prv-prospecting-data': esPrvProspectingData,
        'user-dashboard': esUserDashboard,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    defaultNS: 'common',
    ns: [
      'common',
      'home',
      'home-parents',
      'home-educators',
      'home-community',
      'budget-planner',
      'budget-planner-guide',
      'food-truck-planner',
      'food-truck-planner-guide',
      'credit-assessment',
      'credit-assessment-guide',
      'retirement-planner',
      'retirement-planner-guide',
      'understanding-taxes',
      'understanding-taxes-guide',
      'admin',
      'navigation',
      'allowance-savings-elem',
      'charitable-giving-elem',
      'goal-setting-elem',
      'lemonade-stand-elem',
      'wants-needs-elem',
      'subscription-plans',
      'prv-prospecting',
      'prv-prospecting-data',
      'user-dashboard',
    ],
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
